import { render, staticRenderFns } from "./ColorTag.vue?vue&type=template&id=44f5ff68&scoped=true&"
import script from "./ColorTag.vue?vue&type=script&lang=js&"
export * from "./ColorTag.vue?vue&type=script&lang=js&"
import style0 from "./ColorTag.vue?vue&type=style&index=0&id=44f5ff68&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f5ff68",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44f5ff68')) {
      api.createRecord('44f5ff68', component.options)
    } else {
      api.reload('44f5ff68', component.options)
    }
    module.hot.accept("./ColorTag.vue?vue&type=template&id=44f5ff68&scoped=true&", function () {
      api.rerender('44f5ff68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/trips/ColorTag.vue"
export default component.exports